module.exports = __webpack_public_path__ + "static/16_NBA-0a71b7966354904d823ed11cf6a15aab.png";